<template>
  <div class="multi-selection-table-container no-select scroll-fire-fox">
    <table class="multi-selection-table" id="table">
      <tr class="table-header">
        <th class="object-index" />
        <th>Layer</th>
        <th>ID</th>
        <th>Label</th>
      </tr>

      <tr
        class="table-body"
        v-for="(object, objectIndex) in objects"
        :key="objectIndex"
      >
        <td class="object-index">
          {{ objectIndex + 1 }}
        </td>

        <td class="input-disabled">
          {{ object.layer }}
        </td>

        <td class="input-disabled">
          {{ object[prefix + "_id"] }}
        </td>

        <td class="input-disabled">
          {{
            object.hasOwnProperty(prefix + "_label")
              ? object[prefix + "_label"]
              : "-"
          }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "MultipleObjectsMultipleLayersTable",

  props: {
    objects: {
      type: Array
    },

    prefix: {
      type: String
    },

    headers: {
      type: Array,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Organisms/MultipleObjectsMultipleLayersTable.vue